module.exports = __webpack_public_path__ + "static/img/logo.3de5b0a9.png";